import React from "react"

import AuthGuard from "../../features/ui/containers/AuthGuard"
import EBooks from "../../features/myLibrary/containers/EBooks"
import BackBar from "../../features/ui/components/Backbar"
import PageLayout from "../../layouts/PageLayout"

const Ebooks = () => (
  <AuthGuard>
    <PageLayout
      bg="dark.7"
      banner={() => (
        <>
          <BackBar />
        </>
      )}
    >
      <EBooks />
    </PageLayout>
  </AuthGuard>
)

export default Ebooks
